import { initViewMode } from '@/javascripts/editor/init_view_mode';
import { initTabSwitcher } from '@/javascripts/tab_switcher';

document.addEventListener('DOMContentLoaded', () => {
  initViewMode();

  initTabSwitcher('.js-privacy-policy-tab', '.js-privacy-policy-content');
});
